<template>
  <div>
    <div class="content">
      <div class="top">登录白名单管理</div>
      <div class="from">
        <el-form ref="form" :model="form" :inline="true">
          <el-form-item label="手机号">
            <el-input v-model="form.phone" clearable style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="来源">
            <el-select v-model="form.sourceType" placeholder="请选择" style="width: 200px;">
              <el-option v-for="item in sourceTypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryInfo">查询</el-button>
            <el-button type="primary" @click="editUpload({},'新建')">新建</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tab">
        <el-table :data="applyProList" style="width: 100%">
          <el-table-column prop="phone" :align="'center'" label="手机号">
            <template slot-scope="scope">{{scope.row.phone}}</template>
          </el-table-column>
          <el-table-column prop="sourceType" :align="'center'" label="来源" >
            <template slot-scope="scope">{{sourceTypeList.find(item => item.value == scope.row.sourceType) ? sourceTypeList.find(item => item.value == scope.row.sourceType).label : ''}}</template>
          </el-table-column>
          <el-table-column prop="remark" :align="'center'" label="备注" >
            <template slot-scope="scope">{{scope.row.remark}}</template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="260">
          <template slot-scope="{ row }">
            <el-button @click="editUpload(row,'编辑')" type="text">编辑</el-button>
            <span> | </span>
            <el-button @click="deletUpload(row)" type="text">删除</el-button>
          </template>
        </el-table-column>
        </el-table>
        <div>
        <el-dialog
          @close="handleCloseDialog"
          :close-on-click-modal="false"
          :title="bankTitle"
          :visible.sync="dialogUpload"
          width="600px"
        >
          <div>
            <div>
              <el-form :rules="rules" ref="formRef" :model="modeUploadForm" label-width="160px">
                <el-form-item label="手机号:" prop="phone">
                  <el-input v-model="modeUploadForm.phone" autocomplete="off" style="width: 280px;"></el-input>
                </el-form-item>
                <el-form-item label="来源:" prop="sourceType">
                  <el-select v-model="modeUploadForm.sourceType" placeholder="请选择" style="width: 280px;">
                    <el-option v-for="item in sourceTypeList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="备注:">
                  <el-input v-model="modeUploadForm.remark" autocomplete="off" style="width: 280px;"></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitUpload">确 定</el-button>
          </span>
        </el-dialog>
      </div>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next"
            :total="this.total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { selectList, addWhiteList, modWhiteList, delWhiteList } from '@/api/whiteList'
export default {
  props:{
    getSourceType: String,
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      bankTitle:'',
      dialogUpload: false,
      rules: {
        phone: [{ validator: checkPhone, required: true, trigger: "blur" }],
        sourceType: [
          { required: true, message: "请输入来源", trigger: "blur" }
        ],
      },
      sourceTypeList: [
        // { label: "企业", value: 1 },
        { label: "银行", value: '2' },
        { label: "审核人", value: '3' },
        { label: "监管", value: '4' }
      ],
      modeUploadForm: {
        id: '',
        phone: "",
        sourceType: "",
        remark: ""
      },
      form: {
        phone:'',//手机号
        userName:'',//用户名
        status:'',//状态精确匹配：1 启用 / 0 禁用
        sourceType:'',//账号类型精确匹配：1 企业 / 2 银行
        page: 1,
        pageSize: 10
      },
      applyProList: [],
      total: 0
    };
  },
  created() {
    this.getcheckinListList();
  },
  methods: {
    deletUpload(row){
      this.$confirm('是否删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delWhiteList({id: row.id}).then(res=>{
          if(res.data.code == 200){
            this.$message.success(res.data.msg)
            this.getcheckinListList()
          }else{
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    submitUpload(){
      this.$refs.formRef.validate((valid) => {
        if(valid){
          if(this.bankTitle == '编辑'){
            modWhiteList(this.modeUploadForm).then(res=>{
              if(res.data.code == 200){
                this.$message.success(res.data.msg)
                this.handleCloseDialog()
                this.getcheckinListList()
              }else{
                this.$message.error(res.data.msg)
              }
            })
          }else if(this.bankTitle == '新建'){
            addWhiteList(this.modeUploadForm).then(res=>{
              if(res.data.code == 200){
                this.$message.success(res.data.msg)
                this.handleCloseDialog()
                this.getcheckinListList()
              }else{
                this.$message.error(res.data.msg)
              }
            })
          }
        }
      })
    },
    handleCloseDialog() {
      this.modeUploadForm = {
        id: '',
        phone: "",
        sourceType: "",
        remark: ""
      };
      this.dialogUpload = false;
    },
    editUpload(row,type){
      this.bankTitle = type
      if(type == '新建'){
        this.modeUploadForm = {
          phone: "",
          sourceType: "",
          remark: ""
        };
      }else if(type == '编辑'){
        this.modeUploadForm = {
          id: row.id?row.id:'',
          phone: row.phone?row.phone:'',
          sourceType: row.sourceType?row.sourceType:'',
          remark: row.remark?row.remark:''
        };
      }
      this.dialogUpload = true
    },
    getBankStatus(num, row){
      if(row.bankList[num] && row.bankList[num].reqStatus!= null){
        return row.bankList[num].reqStatus
      }else{
        return '-'
      }
    },
    // 查询
    queryInfo() {
      this.form.page = 1
      this.getcheckinListList();
    },
    async getcheckinListList() {
      let searchForm = {
        ...this.form
      }
      selectList(searchForm).then(res=>{
        if(res.data.code == 200){
          this.applyProList = res.data.data.list;
          this.total = res.data.data.total;
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.getcheckinListList();
    }
  }
};
</script>
<style lang='less' scoped>
.content {
  min-height: 894px;
  margin-top: 10px;
  background-color: #fff;
  border-radius: 8px;
  padding-top: 10px;
  padding-bottom: 20px;
  width: 1050px;
  .top {
    height: 30px;
    border-left: 8px solid #2981ee;
    padding-left: 38px;
    box-sizing: border-box;
    font-size: 22px;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #2981ee;
    line-height: 30px;
  }
  .from {
    margin-top: 37px;
    margin-left: 38px;
  }
  .dowm {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding-right: 40px;
    box-sizing: border-box;
    /deep/ .el-button {
      width: 157px;
      height: 40px;
      background: #2981ee;
      border-radius: 6px;
      color: #fff;
    }
  }
  .tab {
    box-sizing: border-box;
    margin-top: 15px;
    min-height: 700px;
    user-select: text;
    .block {
      margin-top: 20px;
      display: flex;
      justify-content: center;
    }
    /deep/ .el-table th {
      background: #f3f4f9;
    }
  }

}
</style> 